import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/view/login.vue'
import Forgot from "@/view/forgot.vue";
import Home from "@/view/home.vue";
import Register from "@/view/register.vue";
import Service from "@/view/service.vue";

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
var router = new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta:{
        title: '登录',
        keepAlive: true
      }
    },
    {
      path: '/forgot',
      name: 'Forgot',
      component: Forgot,
      meta:{
        title: '重置密码',
        keepAlive: true
      }
    },{
      path: '/service',
      name: 'Service',
      component: Service,
      meta:{
        title: '服务协议',
        keepAlive: true
      }
    },{
      path: '/register',
      name: 'Register',
      component: Register,
      meta:{
        title: '注册账号',
        keepAlive: true
      }
    },
    {
      path:"/",
      redirect:"/show",
      meta:{
        title: "首页"
      },
      component:()=>import("@/view/home.vue"),
      children:[{
        meta: {
          title: '首页',
        },
        path: '/show',
        component: () => import('@/view/headers/show.vue')
      },
        {
        meta: {
          title: '购买',
        },
        path: '/buy',
        component: () => import('@/view/headers/buy.vue')
      }, {
          meta: {
            title: '线路列表',
          },
          path: '/line',
          component: () => import('@/view/headers/line.vue')
        },{
          meta: {
            title: '问题反馈',
          },
          path: '/problem',
          component: () => import('@/view/footers/problem.vue')
        },{
          meta: {
            title: '修改密码',
          },
          path: '/alertpwd',
          component: () => import('@/view/headers/alertpwd.vue')
        },{
          meta: {
            title: '联系我们',
          },
          path: '/contactus',
          component: () => import('@/view/footers/contactus.vue')
        },{
          meta: {
            title: '信息公告',
          },
          path: '/information',
          component: () => import('@/view/footers/information.vue')
        },{
          meta: {
            title: '使用指南',
          },
          path: '/usage',
          component: () => import('@/view/footers/usage.vue')
        }]
    }],
  mode:'history'
})

router.beforeEach((to, from, next) => {
  const userId = to.query.ant_ch;
  console.log(to.query.ant_ch);
  console.log(to.query);
  if (userId) {

    localStorage.setItem('ch_id', userId);
  }
  next();
});

// 修复Router.prototype.push的调用错误处理

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js